export default "__VITE_ASSET__DyizC$9w__"